<template>
<Clients />
</template>

<script>
import Clients from '../../components/ContactCenter/ClientsComponent';

export default {
    components: {
        Clients,
    },
};
</script>
